'use strict'

getMultiCookies = (re) ->
  res = []
  for pair in document.cookie.split(/\s*;\s*/)
    if (m = pair.match /^([^=]+)=(.*)/)
      [..., key, val] = m
      res.push [key, decodeURIComponent(val).replace(/\+/g, ' ')] if re.test key
  res

addPerfVars = (performance) ->
  if BOOMR.t_header? && window.performance?.timing?.requestStart?
    BOOMR.addVar('t_header', (BOOMR.t_header - window.performance.timing.requestStart))

  if OptimizeSuite.TrackingHub.page?
    pageData = OptimizeSuite.TrackingHub.page.data()
    BOOMR.addVar "page_channel", pageData.channel ? ""
    BOOMR.addVar "page_country", pageData.country ? ""
    BOOMR.addVar "page_division", pageData.division ? ""
    BOOMR.addVar "page_type", pageData.type ? ""

  # Include Akamai-set experiment test cookies:
  # x-aaa=in;x-other=false => aaa=in,other=false
  xCookies = getMultiCookies /^x-/
  if xCookies.length
    BOOMR.addVar "x_cookies",
      xCookies.map(([name, val]) -> "#{name[2..]}=#{val}").join(',')

  if bodySize = window.performance?.getEntriesByType?('navigation')[0]?.decodedBodySize
    BOOMR.addVar('body_size', bodySize)

  OptimizeSuite.TrackingHub.add "performance", {performance}

onloadScript = (parent = window.parent) ->
  w = window
  if w != parent
    w = parent
    window.BOOMR = w.BOOMR
    window.Groupon = w.Groupon
    window.OptimizeSuite = w.OptimizeSuite
    window.applicationConfig = w.applicationConfig

  defaultConfig =
    user_ip: BOOMR.utils.getCookie('b')
    beacon_url: "/analytic/view.gif"
    BW: { enabled: false }
    DNS: { enabled: false }
    autorun: false

  if applicationConfig?
    for key of applicationConfig
      if applicationConfig[key]?
        defaultConfig[key] = applicationConfig[key]

  BOOMR.init(defaultConfig)

  if BOOMR.t_lstart?
    BOOMR.addVar("t_lstart", BOOMR.t_lstart)

  for timer of BOOMR.gtimers
    BOOMR.addVar(timer, BOOMR.gtimers[timer])

  BOOMR.subscribe 'before_beacon', addPerfVars

  BOOMR.t_end = new Date().getTime()
  BOOMR.addVar "t_end", BOOMR.t_end
  if BOOMR.t_done?
    BOOMR.plugins.RT.endTimer "t_done", BOOMR.t_done
    BOOMR.page_ready()

externalObjectLoader = (url, onLoadHandler, id = 'js-iframe-async') ->
  iframe = document.createElement('iframe')
  iframe.id = 'boomr-frame'
  iframe.src = "javascript:false"
  iframe.setAttribute('aria-hidden', 'true')
  iframe.hidden = "hidden"
  (iframe.frameElement || iframe).style.cssText = '''
    width: 0; height: 0; border: 0; position: absolute
  '''
  iframe.frameBorder = 0
  where = document.getElementsByTagName('script')
  where = where[where.length - 1]
  where.parentNode.insertBefore(iframe, where)

  try
    doc = iframe.contentWindow.document
  catch
    dom = document.domain
    iframe.src = "javascript: var d = document.open();d.domain='" + dom + "';void(0);"
    doc = iframe.contentWindow.document
  doc.open()._load3po = ->
    @domain = dom if dom?

    scriptInit = @createElement("script")
    scriptInit.type = "text/javascript"
    # IE<9 chokes on innerHTML
    scriptInit.text = "Groupon = window.parent.Groupon;$ = window.parent.$"
    @body.appendChild(scriptInit)

    js = @createElement("script")
    js.type = "text/javascript"
    js.id = id
    js.src = url
    if onLoadHandler?
      js.onload = -> onLoadHandler()
    @body.appendChild(js)

  doc.write('<body onload="document._load3po();">')
  doc.close()

perflibLoader = -> #v2.4.5
  w = window
  w = window.parent if(w != w.parent)
  frames = w.frames
  found = false
  frameId = 'boomr-if-as'
  for frame in frames
    try
      if frame?.frames['boomr-if-as']?
        found = true
        break
    catch
  url = Groupon?.Performance?.boomerangUrl or '/layout/assets/boomerang-basic-custom-0_9_3.js'
  externalObjectLoader(url, onloadScript, frameId) if !found

# expose for testing
perflibLoader.getMultiCookies = getMultiCookies
perflibLoader.addPerfVars = addPerfVars
perflibLoader.onloadScript = onloadScript
perflibLoader.externalObjectLoader = externalObjectLoader

module.exports = perflibLoader



// WEBPACK FOOTER //
// ./src/frontend/core/perflibLoader.coffee